export const CITIES: Record<
  string,
  { city: string; lat: number; lng: number; voivodeship: string; isTop?: boolean }
> = {
  warszawa: {
    city: "Warszawa",
    lat: 52.23,
    lng: 21.0111,
    voivodeship: "mazowieckie",
    isTop: true,
  },
  krakow: {
    city: "Kraków",
    lat: 50.0614,
    lng: 19.9372,
    voivodeship: "małopolskie",
    isTop: true,
  },
  wroclaw: {
    city: "Wrocław",
    lat: 51.11,
    lng: 17.0325,
    voivodeship: "dolnośląskie",
    isTop: true,
  },
  lodz: {
    city: "Łódź",
    lat: 51.7769,
    lng: 19.4547,
    voivodeship: "łódzkie",
    isTop: true,
  },
  poznan: {
    city: "Poznań",
    lat: 52.4083,
    lng: 16.9336,
    voivodeship: "wielkopolskie",
    isTop: true,
  },
  gdansk: {
    city: "Gdańsk",
    lat: 54.3475,
    lng: 18.6453,
    voivodeship: "pomorskie",
    isTop: true,
  },
  szczecin: {
    city: "Szczecin",
    lat: 53.4325,
    lng: 14.5481,
    voivodeship: "zachodniopomorskie",
    isTop: true,
  },
  bydgoszcz: {
    city: "Bydgoszcz",
    lat: 53.1219,
    lng: 18.0003,
    voivodeship: "kujawsko-pomorskie",
    isTop: true,
  },
  lublin: {
    city: "Lublin",
    lat: 51.25,
    lng: 22.5667,
    voivodeship: "lubelskie",
    isTop: true,
  },
  bialystok: {
    city: "Białystok",
    lat: 53.1353,
    lng: 23.1456,
    voivodeship: "podlaskie",
    isTop: true,
  },
  katowice: {
    city: "Katowice",
    lat: 50.2625,
    lng: 19.0217,
    voivodeship: "śląskie",
    isTop: true,
  },
  gdynia: {
    city: "Gdynia",
    lat: 54.5175,
    lng: 18.54,
    voivodeship: "pomorskie",
  },
  "zielona-gora": {
    city: "Zielona Góra",
    lat: 51.9333,
    lng: 15.5,
    voivodeship: "lubuskie",
  },
  czestochowa: {
    city: "Częstochowa",
    lat: 50.8,
    lng: 19.1167,
    voivodeship: "śląskie",
  },
  radom: {
    city: "Radom",
    lat: 51.4036,
    lng: 21.1567,
    voivodeship: "mazowieckie",
    isTop: true,
  },
  torun: {
    city: "Toruń",
    lat: 53.0222,
    lng: 18.6111,
    voivodeship: "kujawsko-pomorskie",
  },
  rzeszow: {
    city: "Rzeszów",
    lat: 50.0333,
    lng: 22,
    voivodeship: "podkarpackie",
    isTop: true,
  },
  sosnowiec: {
    city: "Sosnowiec",
    lat: 50.2833,
    lng: 19.1333,
    voivodeship: "śląskie",
  },
  kielce: {
    city: "Kielce",
    lat: 50.8742,
    lng: 20.6333,
    voivodeship: "Świętokrzyskie",
    isTop: true,
  },
  gliwice: {
    city: "Gliwice",
    lat: 50.2833,
    lng: 18.6667,
    voivodeship: "śląskie",
  },
  olsztyn: {
    city: "Olsztyn",
    lat: 53.7778,
    lng: 20.4792,
    voivodeship: "warmińsko-mazurskie",
    isTop: true,
  },
  "bielsko-biala": {
    city: "Bielsko-Biała",
    lat: 49.8225,
    lng: 19.0444,
    voivodeship: "śląskie",
  },
  zabrze: {
    city: "Zabrze",
    lat: 50.3025,
    lng: 18.7781,
    voivodeship: "śląskie",
  },
  bytom: {
    city: "Bytom",
    lat: 50.3483,
    lng: 18.9156,
    voivodeship: "śląskie",
  },
  "ruda-slaska": {
    city: "Ruda Śląska",
    lat: 50.2628,
    lng: 18.8536,
    voivodeship: "śląskie",
  },
  rybnik: {
    city: "Rybnik",
    lat: 50.0833,
    lng: 18.55,
    voivodeship: "śląskie",
  },
  opole: {
    city: "Opole",
    lat: 50.6667,
    lng: 17.9333,
    voivodeship: "Opolskie",
  },
  tychy: {
    city: "Tychy",
    lat: 50.1236,
    lng: 18.9867,
    voivodeship: "śląskie",
  },
  "gorzow-wielkopolski": {
    city: "Gorzów Wielkopolski",
    lat: 52.7333,
    lng: 15.25,
    voivodeship: "lubuskie",
  },
  "dabrowa-gornicza": {
    city: "Dąbrowa Górnicza",
    lat: 50.3214,
    lng: 19.1872,
    voivodeship: "śląskie",
  },
  elblag: {
    city: "Elbląg",
    lat: 54.1667,
    lng: 19.4,
    voivodeship: "warmińsko-mazurskie",
  },
  plock: {
    city: "Płock",
    lat: 52.55,
    lng: 19.7,
    voivodeship: "mazowieckie",
  },
  tarnow: {
    city: "Tarnów",
    lat: 50.0125,
    lng: 20.9886,
    voivodeship: "małopolskie",
  },
  koszalin: {
    city: "Koszalin",
    lat: 54.2,
    lng: 16.1833,
    voivodeship: "zachodniopomorskie",
  },
  wloclawek: {
    city: "Włocławek",
    lat: 52.6592,
    lng: 19.0681,
    voivodeship: "kujawsko-pomorskie",
  },
  walbrzych: {
    city: "Wałbrzych",
    lat: 50.7667,
    lng: 16.2833,
    voivodeship: "dolnośląskie",
  },
  chorzow: {
    city: "Chorzów",
    lat: 50.3,
    lng: 18.95,
    voivodeship: "śląskie",
  },
  kalisz: {
    city: "Kalisz",
    lat: 51.7575,
    lng: 18.08,
    voivodeship: "wielkopolskie",
  },
  legnica: {
    city: "Legnica",
    lat: 51.2083,
    lng: 16.1603,
    voivodeship: "dolnośląskie",
  },
  "nowy-sacz": {
    city: "Nowy Sącz",
    lat: 49.6239,
    lng: 20.6972,
    voivodeship: "małopolskie",
  },
  myslowice: {
    city: "Mysłowice",
    lat: 50.2333,
    lng: 19.1333,
    voivodeship: "śląskie",
  },
  "ostrow-wielkopolski": {
    city: "Ostrów Wielkopolski",
    lat: 51.6494,
    lng: 17.8164,
    voivodeship: "wielkopolskie",
  },
  lubin: {
    city: "Lubin",
    lat: 51.4,
    lng: 16.2,
    voivodeship: "dolnośląskie",
  },
  inowroclaw: {
    city: "Inowrocław",
    lat: 52.7931,
    lng: 18.2611,
    voivodeship: "kujawsko-pomorskie",
  },
  "stargard-szczecinski": {
    city: "Stargard Szczeciński",
    lat: 53.3333,
    lng: 15.0333,
    voivodeship: "zachodniopomorskie",
  },
  gniezno: {
    city: "Gniezno",
    lat: 52.5358,
    lng: 17.5958,
    voivodeship: "wielkopolskie",
  },
  pruszkow: {
    city: "Pruszków",
    lat: 52.1667,
    lng: 20.8,
    voivodeship: "mazowieckie",
  },
  "ostrowiec-swietokrzyski": {
    city: "Ostrowiec Świętokrzyski",
    lat: 50.9333,
    lng: 21.4,
    voivodeship: "Świętokrzyskie",
  },
  "siemianowice-slaskie": {
    city: "Siemianowice śląskie",
    lat: 50.2758,
    lng: 18.9858,
    voivodeship: "śląskie",
  },
  glogow: {
    city: "Głogów",
    lat: 51.6589,
    lng: 16.0803,
    voivodeship: "dolnośląskie",
  },
  pabianice: {
    city: "Pabianice",
    lat: 51.65,
    lng: 19.3833,
    voivodeship: "łódzkie",
  },
  leszno: {
    city: "Leszno",
    lat: 51.8458,
    lng: 16.5806,
    voivodeship: "wielkopolskie",
  },
  elk: {
    city: "Ełk",
    lat: 53.8214,
    lng: 22.3622,
    voivodeship: "warmińsko-mazurskie",
  },
  zamosc: {
    city: "Zamość",
    lat: 50.7167,
    lng: 23.2528,
    voivodeship: "lubelskie",
  },
  chelm: {
    city: "Chełm",
    lat: 51.1322,
    lng: 23.4778,
    voivodeship: "lubelskie",
  },
  "tomaszow-mazowiecki": {
    city: "Tomaszów Mazowiecki",
    lat: 51.5167,
    lng: 20.0167,
    voivodeship: "łódzkie",
  },
  mielec: {
    city: "Mielec",
    lat: 50.2833,
    lng: 21.4333,
    voivodeship: "podkarpackie",
  },
  tczew: {
    city: "Tczew",
    lat: 54.0875,
    lng: 18.7972,
    voivodeship: "pomorskie",
  },
  bedzin: {
    city: "Będzin",
    lat: 50.3333,
    lng: 19.1167,
    voivodeship: "śląskie",
  },
  zgierz: {
    city: "Zgierz",
    lat: 51.85,
    lng: 19.4167,
    voivodeship: "łódzkie",
  },
  swidnica: {
    city: "Świdnica",
    lat: 50.85,
    lng: 16.4833,
    voivodeship: "dolnośląskie",
  },
  belchatow: {
    city: "Bełchatów",
    lat: 51.3667,
    lng: 19.3667,
    voivodeship: "łódzkie",
  },
  legionowo: {
    city: "Legionowo",
    lat: 52.4,
    lng: 20.8833,
    voivodeship: "mazowieckie",
  },
  "piekary-slaskie": {
    city: "Piekary śląskie",
    lat: 50.3833,
    lng: 18.95,
    voivodeship: "śląskie",
  },
  rumia: {
    city: "Rumia",
    lat: 54.5667,
    lng: 18.4,
    voivodeship: "pomorskie",
  },
  ostroleka: {
    city: "Ostrołęka",
    lat: 53.0667,
    lng: 21.5667,
    voivodeship: "mazowieckie",
  },
  wejherowo: {
    city: "Wejherowo",
    lat: 54.6,
    lng: 18.25,
    voivodeship: "pomorskie",
  },
  swietochlowice: {
    city: "Świętochłowice",
    lat: 50.2919,
    lng: 18.9178,
    voivodeship: "śląskie",
  },
  "starogard-gdanski": {
    city: "Starogard Gdański",
    lat: 53.9667,
    lng: 18.5333,
    voivodeship: "pomorskie",
  },
  starachowice: {
    city: "Starachowice",
    lat: 51.05,
    lng: 21.0667,
    voivodeship: "Świętokrzyskie",
  },
  kolobrzeg: {
    city: "Kołobrzeg",
    lat: 54.1761,
    lng: 15.5761,
    voivodeship: "zachodniopomorskie",
  },
  debica: {
    city: "Dębica",
    lat: 50.05,
    lng: 21.4167,
    voivodeship: "podkarpackie",
  },
  zabki: {
    city: "Ząbki",
    lat: 52.2928,
    lng: 21.1161,
    voivodeship: "mazowieckie",
  },
  marki: {
    city: "Marki",
    lat: 52.3333,
    lng: 21.1,
    voivodeship: "mazowieckie",
  },
  "minsk-mazowiecki": {
    city: "Mińsk Mazowiecki",
    lat: 52.1833,
    lng: 21.5667,
    voivodeship: "mazowieckie",
  },
  zyrardow: {
    city: "Żyrardów",
    lat: 52.05,
    lng: 20.4333,
    voivodeship: "mazowieckie",
  },
  chojnice: {
    city: "Chojnice",
    lat: 53.7,
    lng: 17.55,
    voivodeship: "pomorskie",
  },
  swidnik: {
    city: "Świdnik",
    lat: 51.2167,
    lng: 22.7,
    voivodeship: "lubelskie",
  },
  kwidzyn: {
    city: "Kwidzyn",
    lat: 53.7358,
    lng: 18.9308,
    voivodeship: "pomorskie",
  },
  malbork: {
    city: "Malbork",
    lat: 54.0333,
    lng: 19.0333,
    voivodeship: "pomorskie",
  },
  boleslawiec: {
    city: "Bolesławiec",
    lat: 51.2667,
    lng: 15.5667,
    voivodeship: "dolnośląskie",
  },
  oswiecim: {
    city: "Oświęcim",
    lat: 50.0381,
    lng: 19.2214,
    voivodeship: "małopolskie",
  },
  "nowa-sol": {
    city: "Nowa Sól",
    lat: 51.8,
    lng: 15.7167,
    voivodeship: "lubuskie",
  },
  knurow: {
    city: "Knurów",
    lat: 50.2167,
    lng: 18.6833,
    voivodeship: "śląskie",
  },
  wolomin: {
    city: "Wołomin",
    lat: 52.35,
    lng: 21.2333,
    voivodeship: "mazowieckie",
  },
  zary: {
    city: "Żary",
    lat: 51.6333,
    lng: 15.1333,
    voivodeship: "lubuskie",
  },
  olesnica: {
    city: "Oleśnica",
    lat: 51.2,
    lng: 17.3833,
    voivodeship: "dolnośląskie",
  },
  "czechowice-dziedzice": {
    city: "Czechowice-Dziedzice",
    lat: 49.9131,
    lng: 19.0064,
    voivodeship: "śląskie",
  },
  lebork: {
    city: "Lębork",
    lat: 54.55,
    lng: 17.75,
    voivodeship: "pomorskie",
  },
  brzeg: {
    city: "Brzeg",
    lat: 50.8667,
    lng: 17.4833,
    voivodeship: "Opolskie",
  },
  sochaczew: {
    city: "Sochaczew",
    lat: 52.2333,
    lng: 20.2333,
    voivodeship: "mazowieckie",
  },
  podgorze: {
    city: "podgórze",
    lat: 50.0417,
    lng: 19.9833,
    voivodeship: "małopolskie",
  },
  cieszyn: {
    city: "Cieszyn",
    lat: 49.7484,
    lng: 18.6332,
    voivodeship: "śląskie",
  },
  olawa: {
    city: "Oława",
    lat: 50.9333,
    lng: 17.3,
    voivodeship: "dolnośląskie",
  },
  lubon: {
    city: "Luboń",
    lat: 52.3333,
    lng: 16.8833,
    voivodeship: "wielkopolskie",
  },
  sopot: {
    city: "Sopot",
    lat: 54.4333,
    lng: 18.55,
    voivodeship: "pomorskie",
  },
  ilawa: {
    city: "Iława",
    lat: 53.5964,
    lng: 19.5656,
    voivodeship: "warmińsko-mazurskie",
  },
  krasnik: {
    city: "Kraśnik",
    lat: 50.9167,
    lng: 22.2167,
    voivodeship: "lubelskie",
  },
  dzierzoniow: {
    city: "Dzierżoniów",
    lat: 50.7281,
    lng: 16.6511,
    voivodeship: "dolnośląskie",
  },
  "pruszcz-gdanski": {
    city: "Pruszcz Gdański",
    lat: 54.2667,
    lng: 18.6333,
    voivodeship: "pomorskie",
  },
  czeladz: {
    city: "Czeladź",
    lat: 50.3333,
    lng: 19.0833,
    voivodeship: "śląskie",
  },
  rury: {
    city: "Rury",
    lat: 51.2386,
    lng: 22.5164,
    voivodeship: "lubelskie",
  },
  zgorzelec: {
    city: "Zgorzelec",
    lat: 51.15,
    lng: 15.0083,
    voivodeship: "dolnośląskie",
  },
  brodnica: {
    city: "Brodnica",
    lat: 53.2597,
    lng: 19.3956,
    voivodeship: "kujawsko-pomorskie",
  },
  gizycko: {
    city: "Giżycko",
    lat: 54.04,
    lng: 21.7589,
    voivodeship: "warmińsko-mazurskie",
  },
  kobylka: {
    city: "Kobyłka",
    lat: 52.3333,
    lng: 21.2,
    voivodeship: "mazowieckie",
  },
  lowicz: {
    city: "Łowicz",
    lat: 52.1,
    lng: 19.9333,
    voivodeship: "łódzkie",
  },
  gorlice: {
    city: "Gorlice",
    lat: 49.6547,
    lng: 21.1597,
    voivodeship: "małopolskie",
  },
  ketrzyn: {
    city: "Kętrzyn",
    lat: 54.0833,
    lng: 21.3833,
    voivodeship: "warmińsko-mazurskie",
  },
  halemba: {
    city: "Halemba",
    lat: 50.2378,
    lng: 18.8633,
    voivodeship: "śląskie",
  },
  wagrowiec: {
    city: "Wągrowiec",
    lat: 52.8,
    lng: 17.2,
    voivodeship: "wielkopolskie",
  },
  bilgoraj: {
    city: "Biłgoraj",
    lat: 50.55,
    lng: 22.7333,
    voivodeship: "lubelskie",
  },
  turek: {
    city: "Turek",
    lat: 52.0167,
    lng: 18.5,
    voivodeship: "wielkopolskie",
  },
  skawina: {
    city: "Skawina",
    lat: 49.9833,
    lng: 19.8333,
    voivodeship: "małopolskie",
  },
  koscian: {
    city: "Kościan",
    lat: 52.0833,
    lng: 16.65,
    voivodeship: "wielkopolskie",
  },
  koscierzyna: {
    city: "Kościerzyna",
    lat: 54.1167,
    lng: 17.9833,
    voivodeship: "pomorskie",
  },
  piastow: {
    city: "Piastów",
    lat: 52.1833,
    lng: 20.85,
    voivodeship: "mazowieckie",
  },
  szczytno: {
    city: "Szczytno",
    lat: 53.5628,
    lng: 20.9853,
    voivodeship: "warmińsko-mazurskie",
  },
  bartoszyce: {
    city: "Bartoszyce",
    lat: 54.25,
    lng: 20.8,
    voivodeship: "warmińsko-mazurskie",
  },
  plonsk: {
    city: "Płońsk",
    lat: 52.6333,
    lng: 20.3833,
    voivodeship: "mazowieckie",
  },
  jawor: {
    city: "Jawor",
    lat: 51.05,
    lng: 16.2,
    voivodeship: "dolnośląskie",
  },
  grajewo: {
    city: "Grajewo",
    lat: 53.65,
    lng: 22.45,
    voivodeship: "podlaskie",
  },
  zambrow: {
    city: "Zambrów",
    lat: 52.9833,
    lng: 22.25,
    voivodeship: "podlaskie",
  },
  mragowo: {
    city: "Mrągowo",
    lat: 53.8667,
    lng: 21.3,
    voivodeship: "warmińsko-mazurskie",
  },
  sulejowek: {
    city: "Sulejówek",
    lat: 52.2442,
    lng: 21.28,
    voivodeship: "mazowieckie",
  },
  dzialdowo: {
    city: "Działdowo",
    lat: 53.2333,
    lng: 20.1833,
    voivodeship: "warmińsko-mazurskie",
  },
  lubartow: {
    city: "Lubartów",
    lat: 51.4667,
    lng: 22.6,
    voivodeship: "lubelskie",
  },
  kolo: {
    city: "Koło",
    lat: 52.2,
    lng: 18.6333,
    voivodeship: "wielkopolskie",
  },
  luban: {
    city: "Lubań",
    lat: 51.1181,
    lng: 15.2889,
    voivodeship: "dolnośląskie",
  },
  chelmno: {
    city: "Chełmno",
    lat: 53.3492,
    lng: 18.4231,
    voivodeship: "kujawsko-pomorskie",
  },
  zlotow: {
    city: "Złotów",
    lat: 53.3603,
    lng: 17.0408,
    voivodeship: "wielkopolskie",
  },
  ozorkow: {
    city: "Ozorków",
    lat: 51.9667,
    lng: 19.2833,
    voivodeship: "łódzkie",
  },
  "tomaszow-lubelski": {
    city: "Tomaszów Lubelski",
    lat: 50.45,
    lng: 23.4167,
    voivodeship: "lubelskie",
  },
  giszowiec: {
    city: "Giszowiec",
    lat: 50.2236,
    lng: 19.0694,
    voivodeship: "śląskie",
  },
  lomianki: {
    city: "Łomianki",
    lat: 52.3333,
    lng: 20.8833,
    voivodeship: "mazowieckie",
  },
  chodziez: {
    city: "Chodzież",
    lat: 52.9833,
    lng: 16.9,
    voivodeship: "wielkopolskie",
  },
  jasien: {
    city: "Jasien",
    lat: 54.3667,
    lng: 18.6333,
    voivodeship: "pomorskie",
  },
  lancut: {
    city: "Łańcut",
    lat: 50.0667,
    lng: 22.2333,
    voivodeship: "podkarpackie",
  },
  bogucice: {
    city: "Bogucice",
    lat: 50.2668,
    lng: 19.0397,
    voivodeship: "śląskie",
  },
  milanowek: {
    city: "Milanówek",
    lat: 52.1167,
    lng: 20.65,
    voivodeship: "mazowieckie",
  },
  braniewo: {
    city: "Braniewo",
    lat: 54.3833,
    lng: 19.8333,
    voivodeship: "warmińsko-mazurskie",
  },
  "rawa-mazowiecka": {
    city: "Rawa Mazowiecka",
    lat: 51.7658,
    lng: 20.2533,
    voivodeship: "łódzkie",
  },
  "radzionkow-nowy": {
    city: "Radzionków Nowy",
    lat: 50.3833,
    lng: 18.8833,
    voivodeship: "śląskie",
  },
  osowa: {
    city: "Osowa",
    lat: 54.4272,
    lng: 18.4708,
    voivodeship: "pomorskie",
  },
  rypin: {
    city: "Rypin",
    lat: 53.0667,
    lng: 19.45,
    voivodeship: "kujawsko-pomorskie",
  },
  "lidzbark-warminski": {
    city: "Lidzbark Warmiński",
    lat: 54.1167,
    lng: 20.5833,
    voivodeship: "warmińsko-mazurskie",
  },
  zlotoryja: {
    city: "Złotoryja",
    lat: 51.1333,
    lng: 15.9167,
    voivodeship: "dolnośląskie",
  },
  ustka: {
    city: "Ustka",
    lat: 54.5833,
    lng: 16.85,
    voivodeship: "pomorskie",
  },
  "bialy-kamien": {
    city: "Biały Kamień",
    lat: 50.7814,
    lng: 16.2539,
    voivodeship: "dolnośląskie",
  },
  chelmza: {
    city: "Chełmża",
    lat: 53.1847,
    lng: 18.6042,
    voivodeship: "kujawsko-pomorskie",
  },
  lipno: {
    city: "Lipno",
    lat: 52.85,
    lng: 19.1667,
    voivodeship: "kujawsko-pomorskie",
  },
  leczyca: {
    city: "Łęczyca",
    lat: 52.05,
    lng: 19.2,
    voivodeship: "łódzkie",
  },
  zawodzie: {
    city: "Zawodzie",
    lat: 50.2585,
    lng: 19.0449,
    voivodeship: "śląskie",
  },
  slupca: {
    city: "Słupca",
    lat: 52.3,
    lng: 17.8667,
    voivodeship: "wielkopolskie",
  },
  czluchow: {
    city: "Człuchów",
    lat: 53.65,
    lng: 17.3667,
    voivodeship: "pomorskie",
  },
  wabrzezno: {
    city: "Wąbrzeźno",
    lat: 53.2833,
    lng: 18.95,
    voivodeship: "kujawsko-pomorskie",
  },
  sidlice: {
    city: "Sidlice",
    lat: 54.3471,
    lng: 18.6171,
    voivodeship: "pomorskie",
  },
  siedlce: {
    city: "Siedlce",
    lat: 52.1617,
    lng: 22.2344,
    voivodeship: "mazowieckie",
  },
  chojnow: {
    city: "Chojnów",
    lat: 51.2667,
    lng: 15.9333,
    voivodeship: "dolnośląskie",
  },
  chropaczow: {
    city: "Chropaczów",
    lat: 50.3131,
    lng: 18.915,
    voivodeship: "śląskie",
  },
  koszutka: {
    city: "Koszutka",
    lat: 50.2711,
    lng: 19.0211,
    voivodeship: "śląskie",
  },
  "golub-dobrzyn": {
    city: "Golub-Dobrzyń",
    lat: 53.1,
    lng: 19.05,
    voivodeship: "kujawsko-pomorskie",
  },
  "aleksandrow-kujawski": {
    city: "Aleksandrów Kujawski",
    lat: 52.8767,
    lng: 18.6936,
    voivodeship: "kujawsko-pomorskie",
  },
  puck: {
    city: "Puck",
    lat: 54.7,
    lng: 18.4,
    voivodeship: "pomorskie",
  },
  suchanino: {
    city: "Suchanino",
    lat: 54.3667,
    lng: 18.65,
    voivodeship: "pomorskie",
  },
  czarnkow: {
    city: "Czarnków",
    lat: 52.9,
    lng: 16.5667,
    voivodeship: "wielkopolskie",
  },
  zaleze: {
    city: "Załęże",
    lat: 50.2672,
    lng: 18.9892,
    voivodeship: "śląskie",
  },
  dab: {
    city: "Dąb",
    lat: 50.2739,
    lng: 18.9992,
    voivodeship: "śląskie",
  },
  chruszczow: {
    city: "Chruszczów",
    lat: 50.3333,
    lng: 18.8833,
    voivodeship: "śląskie",
  },
  ksawerow: {
    city: "Ksawerów",
    lat: 51.6822,
    lng: 19.4028,
    voivodeship: "łódzkie",
  },
  "wola-rzedzinska": {
    city: "Wola Rzędzińska",
    lat: 50.05,
    lng: 21.0833,
    voivodeship: "małopolskie",
  },
  "dabrowka-mala": {
    city: "Dąbrówka Mała",
    lat: 50.2769,
    lng: 19.0808,
    voivodeship: "śląskie",
  },
  sejny: {
    city: "Sejny",
    lat: 54.1167,
    lng: 23.3667,
    voivodeship: "podlaskie",
  },
  raciaz: {
    city: "Raciąż",
    lat: 52.7794,
    lng: 20.1153,
    voivodeship: "mazowieckie",
  },
  "gorowo-ilaweckie": {
    city: "Górowo Iławeckie",
    lat: 54.2861,
    lng: 20.4917,
    voivodeship: "warmińsko-mazurskie",
  },
  zglobice: {
    city: "Zgłobice",
    lat: 49.9833,
    lng: 20.9167,
    voivodeship: "małopolskie",
  },
  libertow: {
    city: "Libertów",
    lat: 49.9667,
    lng: 19.8833,
    voivodeship: "małopolskie",
  },
  "zbylitowska-gora": {
    city: "Zbylitowska Góra",
    lat: 49.9833,
    lng: 20.9167,
    voivodeship: "małopolskie",
  },
  "wisniowa-gora": {
    city: "Wiśniowa Góra",
    lat: 51.7167,
    lng: 19.6333,
    voivodeship: "łódzkie",
  },
  koszyce: {
    city: "Koszyce",
    lat: 49.9689,
    lng: 20.9475,
    voivodeship: "małopolskie",
  },
  aleksandrowice: {
    city: "Aleksandrowice",
    lat: 49.8144,
    lng: 19.2333,
    voivodeship: "śląskie",
  },
  latoszyn: {
    city: "Latoszyn",
    lat: 50.0333,
    lng: 21.3667,
    voivodeship: "podkarpackie",
  },
  jodlowka: {
    city: "Jodłówka",
    lat: 50.0628,
    lng: 21.1122,
    voivodeship: "małopolskie",
  },
  "dluga-szlachecka": {
    city: "Długa Szlachecka",
    lat: 52.25,
    lng: 21.3167,
    voivodeship: "mazowieckie",
  },
  kajkowo: {
    city: "Kajkowo",
    lat: 53.6667,
    lng: 19.9667,
    voivodeship: "warmińsko-mazurskie",
  },
};

export const CITIES_OPTIONS = Object.entries(CITIES)
  .map(([id, data]) => ({
    value: id,
    label: data.city,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const CITIES_RANGE_OPTIONS = [
  { value: "10km", label: "10km" },
  { value: "20km", label: "20km" },
  { value: "30km", label: "30km" },
  { value: "40km", label: "40km" },
  { value: "50km", label: "50km" },
  { value: "100km", label: "100km" },
];
